import React from 'react';
import Grid from '@mui/material/Grid';
import CircularProgress from '@mui/material/CircularProgress';

const GlobalLoader = ({ size, style = {} }) => (
  <Grid
    container
    spacing={0}
    direction="column"
    alignItems="center"
    justifyContent="center"
    style={{
      minHeight: size,
      backgroundColor: '#00000017',
      position: 'fixed',
      top: 0,
      left: 0,
      zIndex: 10000000,
      ...style,
    }}
  >
    <CircularProgress />
  </Grid>
);

GlobalLoader.propTypes = {};

export default GlobalLoader;
